<div class="container-fluid container-height">
  <!-- logo and language div   -->
  <div class="d-flex justify-content-center align-items-top contHgt-pdng px-md-4">

  </div>

  <!-- carousel-cards -->
  <div class="row mt-md-4 mrt-md-01 carouselClass">
    <div class="col-12">
      <img [src]="'IMAGES.LOGOIMG' | translate" width="125" alt=""
        style="display: block; margin: 0 auto;margin-bottom: 20px;" />

      <div id="demo" class="carousel slide text-center" data-bs-ride="carousel">
        <!-- Indicators/dots -->
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#demo" data-bs-slide-to="0" class="active"></button>
          <button type="button" data-bs-target="#demo" data-bs-slide-to="1"></button>
          <button type="button" data-bs-target="#demo" data-bs-slide-to="2"></button>
          <button type="button" data-bs-target="#demo" data-bs-slide-to="3"></button>
        </div>

        <!-- The slideshow/carousel -->
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img [src]="'MAINSIDEBARIMAGE.SLIDE1' | translate" alt="" class="img-fluid cursor-pointer sliderImage" />
            <div class="row mt-3 carouselText">
              <div class="col-md-12 text-center">
                <h2 class="get-total-text">
                  {{ "CAROUSELTEXT.TEXT1" | translate }}
                </h2>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img [src]="'MAINSIDEBARIMAGE.SLIDE2' | translate" alt="" class="img-fluid cursor-pointer sliderImage" />
            <div class="row mt-3 carouselText">
              <div class="col-md-12 text-center">
                <h2 class="get-total-text">
                  {{ "CAROUSELTEXT.TEXT2" | translate }}
                </h2>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img [src]="'MAINSIDEBARIMAGE.SLIDE3' | translate" alt="" class="img-fluid cursor-pointer sliderImage" />
            <div class="row mt-3 carouselText">
              <div class="col-md-12 text-center">
                <h2 class="get-total-text">
                  {{ "CAROUSELTEXT.TEXT3" | translate }}
                </h2>
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <img [src]="'MAINSIDEBARIMAGE.SLIDE4' | translate" alt="" class="img-fluid cursor-pointer sliderImage" />
            <div class="row mt-3 carouselText">
              <div class="col-md-12 text-center">
                <h2 class="get-total-text">
                  {{ "CAROUSELTEXT.TEXT4" | translate }}
                </h2>
              </div>
            </div>
          </div>
        </div>

        <!-- Left and right controls/icons -->
        <button class="carousel-control-prev" type="button" data-bs-target="#demo" data-bs-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#demo" data-bs-slide="next">
          <span class="carousel-control-next-icon"></span>
        </button>
      </div>
    </div>
  </div>
</div>